export const environment = {
  production: true,
  hmr: false,
  debug: false,
  client: 'Subaru',
  hostName: 'https://analytics.subarucertifieddigital.com',
  environmentName: 'production',
  appName: 'Subaru Analytics',
  ssoPassword: 'ShiftDigital#123',
  defaultChartColors: ['#000', '#09f', '#A6A6A6', '#D9D9D9', '#CCCCCC'],
  applicationInsights: {
    instrumentationKey: '4b0767b3-2c7c-45d4-b366-0830922656b5'
  },
  defaultLocale: 'en',
  availableLocales: ['en'],
  timeZone: 'Eastern Standard Time',
  numberOfMonthsToShowDefault: 12,
  numberOfQuartersToShowDefault: 8,
  defaultOrgLevelTypeIds: [1],
  closeRateLookbackMonths: 3,
  baseApiUri: 'https://subaru-analytics-api-prod.azurewebsites.net/api',
  authUri: 'https://subaru-analytics-api-prod.azurewebsites.net/token',
  baseV5ApiUri: 'https://subaru-analytics-apiv5-prod.azurewebsites.net/api',
  retailerToolsBaseUri: '',
  retailerToolsIncludeAuth: false,
  mysteryShopBaseUri: '',
  favIconPath: '/assets/icons/clients/Subaru/favicon.ico',
  loginRedirectUrl: '',
  logoutRedirectUrl: '',
  sidebarDefaultOpen: false,
  useV5WebsiteOverview: false,
  v5Reports: [
    'WebsiteOverview',
    'DigitalAdvertisingDashboard',
    'ChatOverview',
    'DigitalRetailingOverview',
    'ProgramOverview']
};
